import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ClientDetail from "@/components/ClientDetail";

// Full-screen client route (/clients/:name) — replaces the old slide-over drawer.
export default function ClientPage() {
  const { name } = useParams();
  const navigate = useNavigate();
  const clientName = decodeURIComponent(name || "");
  return (
    <ClientDetail
      asPage
      name={clientName}
      onClose={() => navigate("/clients")}
      onMerged={() => navigate("/clients")}
    />
  );
}
